import ScrollCarousel, { measureSlidesPerView } from '../../components/ScrollCarousel';

const SELECTORS = {
  viewport: '[data-cms-image-slider-viewport]',
  track: '[data-cms-image-slider-track]',
};

const initSlider = (module_name, i) => {
  const container = document.getElementById(`Module-${module_name}--${i}`);
  if (!container) {
    return;
  }

  const carousel = container.querySelector('[data-cms-image-slider]');
  const viewport = carousel && carousel.querySelector(SELECTORS.viewport);
  const track = carousel && carousel.querySelector(SELECTORS.track);
  if (!viewport || !track || track.children.length === 0) {
    return;
  }

  new ScrollCarousel(carousel, {
    selectors: SELECTORS,
    // Flickity `wrapAround: true`. `imagesLoaded` needs no equivalent —
    // ScrollCarousel.watchImages() remeasures as late images settle, so the
    // flickity-imagesloaded package is no longer needed. `arrowShape` is drawn
    // in SCSS rather than injected as an SVG path.
    loop: true,
    prevNextButtons: true,
    pageDots: true,
    draggable: true,
    slidesPerView: measureSlidesPerView(viewport, track.children[0]),
    ariaLabel: 'Image slider',
  });
};

export { initSlider };
